module.exports = __webpack_public_path__ + "img/photo-62.bf346fb7.webp";